import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { CommonResponse } from '../models/responses/common-response';
import { RequestService } from './request.service';

const root = '/reports/dashboard';

export interface PatientPrintFormStats {
  today_count: number;
  month_count: number;
  weekly_data: Array<{ date: string; count: number }>;
}

export interface PaymentRequestSummary {
  pending: { count: number; total_amount: number };
  approved: { count: number; total_amount: number };
  rejected: { count: number; total_amount: number };
  claimRequestPending: { count: number; total_amount: number };
  total: { count: number; total_amount: number };
}

export interface TopHospital {
  _id: string;
  service_count: number;
  total_amount: number;
  hospital_name: string;
  hospital_name_en: string;
  hospital_code: string;
}

export interface TopHospitalsResponse {
  from_date: string;
  to_date: string;
  hospitals: TopHospital[];
}

@Injectable({
  providedIn: 'root'
})
export class DashboardService {

  constructor(
    private requestService: RequestService
  ) { }

  // Separate endpoint for patient forms - loads in background
  getPatientFormStats(is_loading: boolean = false): Observable<CommonResponse<PatientPrintFormStats>> {
    return this.requestService.postJSON(`${root}/patient-forms`, {
      data: {},
      option: {
        is_loading: is_loading,
        is_snack_bar: false,
      },
    }).pipe(
      catchError(err => {
        console.error('Failed to load patient form stats', err);
        return of({ status: 'error', data: { today_count: 0, month_count: 0, weekly_data: [] } } as any);
      })
    );
  }

  // Separate endpoint for payment summary - loads in background
  getPaymentSummary(is_loading: boolean = false): Observable<CommonResponse<PaymentRequestSummary>> {
    return this.requestService.postJSON(`${root}/payment-summary`, {
      data: {},
      option: {
        is_loading: is_loading,
        is_snack_bar: false,
      },
    }).pipe(
      catchError(err => {
        console.error('Failed to load payment summary', err);
        return of({
          status: 'error',
          data: {
            pending: { count: 0, total_amount: 0 },
            approved: { count: 0, total_amount: 0 },
            rejected: { count: 0, total_amount: 0 },
            total: { count: 0, total_amount: 0 }
          }
        } as any);
      })
    );
  }

    public getCount(
      query?: any,
      is_loading: boolean = true,
      is_snack_bar: boolean = false,
    ): Observable<any> {
      if (!root) throw new Error('Root path is empty');
      return this.requestService.postJSON(`${root}/count-on-menu`, {
        data: query,
        option: {
          is_loading: is_loading,
          is_snack_bar: is_snack_bar,
        },
      });
    }

  // Separate endpoint for top hospitals - loads in background
  getTopHospitals(is_loading: boolean = false): Observable<CommonResponse<TopHospitalsResponse>> {
    return this.requestService.postJSON(`${root}/top-hospitals`, {
      data: {},
      option: {
        is_loading: is_loading,
        is_snack_bar: false,
      },
    }).pipe(
      catchError(err => {
        console.error('Failed to load top hospitals', err);
        return of({ status: 'error', data: { from_date: '', to_date: '', hospitals: [] } } as any);
      })
    );
  }

}
